import React, { useEffect, useState } from 'react';

import { BiX } from 'react-icons/bi';

import Button from '../../../../newComponents/Button';

import * as S from './styles';

import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import { formateBrPrice } from '../../../../utils/formateBrPrice';
import { ICartItem } from '../../../../interfaces/ICartItem';
import { calcOrderPrice } from '../../../../utils/calcOrderPrice';
import { ICustomer } from '../../../../interfaces/ICustomer';
import { useAuth } from '../../../../hooks/auth';
import { IDiscountCoupon } from '../../../../interfaces/IDiscountCoupon';

interface ModalCouponProps {
  cart: ICartItem[];
  selectedClient: ICustomer | null;
  setModalCouponIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleSelectedCoupon: React.Dispatch<any>;
}

const ModalCoupon: React.FC<ModalCouponProps> = (props) => {
  const {
    cart,
    selectedClient,
    handleSelectedCoupon,
    setModalCouponIsOpen,
  } = props;

  const itemsValue = cart
    .map((item) => calcOrderPrice(item))
    .reduce((acc: number, cur: number) => Number(acc) + Number(cur), 0);

  const { addToast } = useToast();
  const { user } = useAuth();

  const [coupons, setCoupons] = useState<IDiscountCoupon[]>([]);
  const [selectedCoupon, setSelectedCoupon] = useState<IDiscountCoupon | null>(
    null,
  );

  const conclusion = (): void => {
    handleSelectedCoupon(selectedCoupon);
    addToast({
      type: 'success',
      title: 'Salvo!',
    });
    setModalCouponIsOpen(false);
  };

  useEffect(() => {
    if (!selectedClient || coupons.length) return;

    const loadCoupons = async (): Promise<void> => {
      try {
        const { data } = await api.get(
          `companies/${user.empresa_id}/discount-coupons`,
          {
            params: { customerId: selectedClient.id },
          },
        );

        if (data.length === 0) {
          addToast({
            type: 'info',
            title: 'Nenhum cupom encontrado.',
          });
          setModalCouponIsOpen(false);
          return;
        }

        setCoupons(data);
      } catch (error) {
        console.log(error);
        addToast({
          type: 'error',
          title: 'Erro ao buscar cupons disponíveis.',
        });
        setModalCouponIsOpen(false);
      }
    };
    loadCoupons();
  }, [
    addToast,
    coupons,
    selectedClient,
    setModalCouponIsOpen,
    user.empresa_id,
  ]);

  return (
    <S.CustomModal
      open
      onClose={() => setModalCouponIsOpen(false)}
      closeAfterTransition
    >
      {coupons.length > 0 ? (
        <div className="body">
          <S.ModalHeader>
            <h1>Cupom de Desconto</h1>
            <button type="button" onClick={() => setModalCouponIsOpen(false)}>
              <BiX />
            </button>
          </S.ModalHeader>

          <S.ModalBody>
            <ul>
              {coupons.map((coupon) => (
                <S.CustomCouponItem
                  key={coupon.id}
                  selected={coupon.id === selectedCoupon?.id}
                  disabled={itemsValue < +(coupon?.minimumSpend ?? 0)}
                  onClick={() => {
                    if (itemsValue < +(coupon.minimumSpend ?? 0)) return;

                    selectedCoupon?.id === coupon.id
                      ? setSelectedCoupon(null)
                      : setSelectedCoupon(coupon);
                  }}
                >
                  <h2>{coupon.code}</h2>
                  <p title={coupon.description}>
                    <strong>Descrição: </strong>
                    {coupon.description}
                  </p>
                  {coupon.minimumSpend && (
                    <p>
                      <strong>Compra mínima: </strong>
                      {formateBrPrice(+coupon.minimumSpend)}
                    </p>
                  )}
                  <p>
                    <strong>Desconto: </strong>
                    {coupon.type === 2
                      ? `${+coupon.value}%`
                      : `${formateBrPrice(+coupon.value)}`}
                  </p>
                  <p>
                    <strong>Subtotal com desconto: </strong>
                    {coupon.type === 2
                      ? formateBrPrice(itemsValue * (1 - +coupon.value / 100))
                      : formateBrPrice(itemsValue - +coupon.value)}
                  </p>
                </S.CustomCouponItem>
              ))}
            </ul>
          </S.ModalBody>

          <S.ModalFooter>
            <Button full onClick={conclusion}>
              Concluir
            </Button>
            <Button
              full
              variant="outlined"
              onClick={() => setModalCouponIsOpen(false)}
            >
              Cancelar
            </Button>
          </S.ModalFooter>
        </div>
      ) : (
        <S.CustomCircularProgress />
      )}
    </S.CustomModal>
  );
};

export default ModalCoupon;
